import { createFileRoute } from '@tanstack/react-router';
import { QuotationsClient } from '@/features/quotations/QuotationsClient';

export const Route = createFileRoute('/_shell/quotations/')({
  component: QuotationsClient,
});
